// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-o_fo","advertDetailService__price":"c-o_fp"};